<div class="metodos-pagamento mt-4">
                <p>Métodos de Pagamento</p>
                <div class="options">
                    <button class="btn" [ngClass]="{'active':pagamentoSelecionado == 'CARTAO'}"
                        (click)="selectPagamento('CARTAO')"><i class="hgi hgi-stroke hgi-credit-card"></i> Cartão de
                        Crédito</button>
                    <button *ngIf="hasBoleto()" class="btn" [ngClass]="{'active':pagamentoSelecionado == 'BOLETO'}"
                        (click)="selectPagamento('BOLETO')"><i class="hgi hgi-stroke hgi-ticket-03"></i>Boleto</button>
                    <button class="btn" [ngClass]="{'active':pagamentoSelecionado == 'PIX'}"
                        (click)="selectPagamento('PIX')"><i class="hgi hgi-stroke hgi-money-receive-circle"></i>
                        Pix</button>
                </div>
                <div *ngIf="pagamentoSelecionado === 'CARTAO'">

                <div class="row form-group">
                    <div class="col-12">
                    <input type="text" class="form-control mt-2"
                            name="numero-cartao"
                            placeholder="{{ 'NumeroCartao' | localize }}"
                            [(ngModel)]="cartaoCredito.numeroCartao"
                            required maxlength="32"
                            mask="0000 0000 0000 0000"
                            #numeroCartaoModel="ngModel" #numeroCartaoEl />
                    <abp-validation-summary 
                        [control]="numeroCartaoModel"
                        [controlEl]="numeroCartaoEl">
                    </abp-validation-summary>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-6">
                    <input type="text" class="form-control mt-2"
                            name="validade-cartao"
                            placeholder="{{ 'ValidadeCartao' | localize }}"
                            [(ngModel)]="cartaoCredito.validade"
                            required maxlength="32"
                            mask="00/00"
                            #validadeCartaoModel="ngModel" #validadeCartaoEl />
                    <abp-validation-summary 
                        [control]="validadeCartaoModel"
                        [controlEl]="validadeCartaoEl">
                    </abp-validation-summary>
                    </div>

                    <div class="col-6">
                    <input type="text" class="form-control mt-2"
                            name="ccv-cartao"
                            placeholder="{{ 'CCV' | localize }}"
                            [(ngModel)]="cartaoCredito.ccv"
                            required maxlength="4"
                            mask="0009"
                            #ccvCartaoModel="ngModel" #ccvCartaoEl />
                    <abp-validation-summary 
                        [control]="ccvCartaoModel"
                        [controlEl]="ccvCartaoEl">
                    </abp-validation-summary>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-6">
                    <input type="text" class="form-control mt-2"
                            name="nome-cartao"
                            placeholder="{{ 'Nome' | localize }}"
                            [(ngModel)]="cartaoCredito.nome"
                            required maxlength="128"
                            #nomeCartaoModel="ngModel" #nomeCartaoEl />
                    <abp-validation-summary 
                        [control]="nomeCartaoModel"
                        [controlEl]="nomeCartaoEl">
                    </abp-validation-summary>
                    </div>

                    <div class="col-6">
                    <input type="text" class="form-control mt-2"
                            name="cpf-cartao"
                            placeholder="CPF"
                            [(ngModel)]="cartaoCredito.cpf"
                            mask="000.000.000-00"
                            required maxlength="14"
                            #cpfCartaoModel="ngModel" #cpfCartaoEl />
                    <abp-validation-summary 
                        [control]="cpfCartaoModel"
                        [controlEl]="cpfCartaoEl">
                    </abp-validation-summary>
                    </div>
                </div>

                </div>


                <div *ngIf="pagamentoSelecionado === 'BOLETO'">
                    <div class="row form-group">
                        <input type="text" class="form-control mt-2" name="cep" placeholder="CEP"
                            [(ngModel)]="endereco.zipCode" maxlength="10" required mask="00.000-000" (ngModelChange)="onSelectCep($event)"
                            #cepModel="ngModel" #cepEl />
                        <abp-validation-summary [control]="cepModel"
                            [controlEl]="cepEl"></abp-validation-summary>
                    </div>
                    <div class="row form-group">
                        <input type="text" class="form-control mt-2" name="estado" placeholder="Estado"
                            [(ngModel)]="endereco.federalUnit" required maxlength="2"
                            #estadoModel="ngModel" #estadoEl [disabled]="desabilitarCamposEndereco"/>
                        <abp-validation-summary [control]="estadoModel" [controlEl]="estadoEl">
                        </abp-validation-summary>
                    </div>
                    <div class="row form-group">
                        <input type="text" class="form-control mt-2" name="cidade" placeholder="Cidade"
                            [(ngModel)]="endereco.city" required 
                            #cidadeModel="ngModel" #cidadeEl [disabled]="desabilitarCamposEndereco"/>
                        <abp-validation-summary [control]="cidadeModel"
                            [controlEl]="cidadeEl"></abp-validation-summary>
                    </div>
                    <div class="row form-group">
                        <input type="text" class="form-control mt-2" name="bairro" placeholder="Bairro"
                            [(ngModel)]="endereco.neighborhood" required 
                            #bairroModel="ngModel" #bairroEl [disabled]="desabilitarCamposEndereco"/>
                        <abp-validation-summary [control]="bairroModel"
                            [controlEl]="bairroEl"></abp-validation-summary>
                    </div>
                    <div class="row form-group">
                        <input type="text" class="form-control mt-2" name="rua" placeholder="Rua"
                            [(ngModel)]="endereco.streetName" required maxlength="128" #ruaModel="ngModel"
                            #ruaEl [disabled]="desabilitarCamposEndereco"/>
                        <abp-validation-summary [control]="ruaModel"
                            [controlEl]="ruaEl"></abp-validation-summary>
                    </div>
                    <div class="row form-group">
                        <input type="text" class="form-control mt-2" name="numero" placeholder="Número"
                            [(ngModel)]="endereco.streetNumber" onlyNumbers required maxlength="128"
                            #numeroModel="ngModel" #numeroEl />
                        <abp-validation-summary [control]="numeroModel"
                            [controlEl]="numeroEl"></abp-validation-summary>
                    </div>
                </div>
            </div>